import * as React from "react";
import { useTranslation } from "react-i18next";

import ContainersTable from "./ContainersTable";
import ApplicationLayout from "components/layout/ApplicationLayout";
import { LICENSES_ROUTE } from "components/router/Routes";
import { useTableRefresh } from "utils/useTableRefresh";

function ContainersView(): JSX.Element {
    const { t } = useTranslation();
    const [state, setState] = React.useState({ count: 0 });
    const { refreshCount, onHandleRefresh } = useTableRefresh();

    function updateState() {
        return setState((prevState) => ({ count: prevState.count + 1 }));
    }

    return (
        <ApplicationLayout
            viewTitle={t("Containers.title")}
            view={<ContainersTable onUpdate={updateState} count={state.count} refreshCount={refreshCount} />}
            mainRoute={LICENSES_ROUTE}
            enableRefresh
            onHandleRefresh={onHandleRefresh}
        />
    );
}

export default ContainersView;
